import type { HandRecord, TableSnapshot } from '@tctp/protocol';
import { useState } from 'react';
import { FullLogTab } from './FullLogTab';
import { HandsTab } from './HandsTab';
import { LedgerTable } from './LedgerTable';
import { Modal } from './Modal';
import { ReplayView } from './ReplayView';

export type SessionTab = 'log' | 'ledger' | 'hands';
const TITLES: Record<SessionTab, string> = { log: 'Session Log', ledger: 'Session Ledger', hands: 'Hands' };
const TABS: Array<[SessionTab, string]> = [['log', 'FULL LOG'], ['ledger', 'LEDGER'], ['hands', 'HANDS']];

/** `compact` (phones): the Hands tab lists the hands and opens the replay straight away, without the street-by-street breakdown. */
export function SessionModal({ snapshot, history, roomId, initialTab, compact = false, onClose }: { snapshot: TableSnapshot; history: HandRecord[]; roomId: string; initialTab: SessionTab; compact?: boolean; onClose: () => void }) {
  const [tab, setTab] = useState<SessionTab>(initialTab);
  const [replay, setReplay] = useState<HandRecord | null>(null);
  return (
    <>
    {replay && <ReplayView record={replay} history={history} onSelect={setReplay} onClose={() => setReplay(null)} />}
    <Modal title={TITLES[tab]} onClose={onClose} wide>
      <div className="session-body">
        {tab === 'log' && <FullLogTab snapshot={snapshot} history={history} roomId={roomId} onReplay={setReplay} />}
        {tab === 'ledger' && <LedgerTable ledger={snapshot.ledger} roomId={roomId} />}
        {tab === 'hands' && <HandsTab history={history} onReplay={setReplay} compact={compact} />}
      </div>
      <div className="session-tabs" role="tablist">
        {TABS.map(([id, label]) => <button key={id} type="button" role="tab" aria-selected={tab === id} className={tab === id ? 'active' : ''} onClick={() => setTab(id)}>{label}</button>)}
      </div>
    </Modal>
    </>
  );
}
